<template>
  <div class="overall-footer">
    <div class="footer-nav">
      <template v-if="activeTab === 'Risk Assessment'">
        <button type="button" class="finalize-btn shadow-sm rounded-lg" @click="$emit('next-tab')">
          <span class="d-flex items-center gap-2">
            {{ hasNoRisk
              ? $t('app.dialog.button.continue')
              : $t('app.assessment_mode.text.input.care_plan_tab') }}
            <v-icon small>{{ icons.mdiArrowRight }}</v-icon>
          </span>
        </button>
      </template>

      <template v-else>
        <button type="button" class="back-btn shadow-sm rounded-lg" @click="$emit('back-tab')">
          <span class="d-flex items-center gap-2">
            <v-icon small>{{ icons.mdiArrowLeft }}</v-icon>
            {{ $t('app.assessment_mode.text.input.risk_assessment_tab') }}
          </span>
        </button>
        <button type="button" class="finalize-btn shadow-sm rounded-lg" @click="$emit('finalize-save')">
          <span class="d-flex items-center gap-2">
            {{ $t(autoSave ? 'app.dialog.button.continue' : 'app.assessment_mode.text.input.finalize_and_save') }}
            <v-icon small>{{ icons.mdiArrowRight }}</v-icon>
          </span>
        </button>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import icons from "@/mixins/icons";
import { defineComponent } from "vue";

export default defineComponent({
  name: 'OverallAssessmentFooter',
  mixins: [icons],
  props: {
    autoSave: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      required: true,
    },
    hasNoRisk: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['next-tab', 'back-tab', 'finalize-save'],
})
</script>
